import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import * as actionType from "../actions";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import MessageModal from "../../shared/components/MessageModal";
// import moment from "moment/moment";
import DataGridPremiumComp from "../../shared/components/DataGridPremiumComp";
const EmailConfiguration = (props) => {
  const { practiceId } = useParams();
  const practiceStoreList = useSelector((state) => state.practices.practices);
  const [practiceEmailMappingId, setPracticeEmailMappingId] = useState("");

  const columns = [
    {
      field: "emailTemplateId",
      headerName: "EMAIL TEMPLATE ID",
      width: 250,
      flex: 2,
      renderCell: ({ row }) => (
        <Typography>
          {row?.emailTemplateId}-
          {
            emailTemplateSettings?.find((item) => {
              return item?.id == row?.emailTemplateId;
            })?.name
          }
        </Typography>
      )
    },
    {
      field: "followUpDays",
      headerName: "FOLLOW UP DAYS",
      width: 100,
      editable: false,
      flex: 1
    },
    {
      field: "emailType",
      headerName: "EMAIL TYPE",
      width: 100,
      editable: false,
      flex: 1
      // renderCell: ({ row }) => (
      //   <IconButton>
      //     <CheckCircleOutlineIcon
      //       color={row.outcome ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
      //   </IconButton>
      // )
    },
    /* {
      field: "agreements",
      headerName: "AGREEMENTS",
      width: 100,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => (
        <IconButton>
          <CheckCircleOutlineIcon
            color={row.agreements ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
        </IconButton>
      )
    }, */
    {
      field: "isActive",
      //headerName: "CLEARANCE/ REJECTION",
      headerName: "IS ACTIVE",
      width: 50,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => (
        <IconButton>
          <CheckCircleOutlineIcon
            color={row.isActive ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
        </IconButton>
      )
    },
    {
      field: "isFollowUpEmail",
      headerName: "IS FOLLOW UP EMAIL",
      width: 100,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => (
        <IconButton>
          <CheckCircleOutlineIcon
            color={row.isFollowUpEmail ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
        </IconButton>
      )
    },
    // {
    //   field: "receipt",
    //   headerName: "RECEIPT",
    //   width: 100,
    //   editable: false,
    //   flex: 1,
    //   renderCell: ({ row }) => (
    //     <IconButton>
    //       <CheckCircleOutlineIcon
    //         color={row.receipt ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
    //     </IconButton>
    //   )
    // },
    // {
    //   field: "refund",
    //   headerName: "REFUND",
    //   width: 100,
    //   editable: false,
    //   flex: 1,
    //   renderCell: ({ row }) => (
    //     <IconButton>
    //       <CheckCircleOutlineIcon
    //         color={row.refund ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
    //     </IconButton>
    //   )
    // },
    // {
    //   field: "termination",
    //   headerName: "TERMINATION",
    //   width: 100,
    //   editable: false,
    //   flex: 1,
    //   renderCell: ({ row }) => (
    //     <IconButton>
    //       <CheckCircleOutlineIcon
    //         color={row.termination ? "primary" : "#8C8C8C"}></CheckCircleOutlineIcon>
    //     </IconButton>
    //   )
    // },
    // {
    //   field: "effectiveDate",
    //   headerName: "EFFECTIVE DATE",
    //   width: 100,
    //   editable: false,
    //   flex: 1,
    //   renderCell: ({ row }) => {
    //     return moment(row.effectiveDate).format("L");
    //   }
    // },

    {
      field: "action",
      headerName: "ACTION",
      width: 50,
      flex: 1,
      filterable: false,
      renderCell: ({ row }) => (
        <IconButton
          onClick={() => {
            handleEditEmailConfiguration(row);
          }}>
          <EditIcon color="primary"></EditIcon>
        </IconButton>
      )
    }
  ];

  let emailConfigurationFormData = {
    practiceId,
    emailTemplateId: "",
    isActive: false,
    followUpDays: 0,
    isFollowUpEmail: false,
    emailType: "",
    createdBy: "",
    updatedBy: ""
  };
  const [pageSize, setPageSize] = useState({
    pageSize: 100,
    page: 0
  });
  const [isOpen, setIsOpen] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [values, setValues] = useState(emailConfigurationFormData);
  const [isMessageModal, setIsMessageModal] = useState(false);
  const [emailTemplateSettingsConfigured, setEmailTemplateSettingsConfigured] = useState([]);
  const {
    emailConfigurationList = [],
    errorMsg,
    successMsg,
    addEmailConfiguration,
    editEmailConfiguration,
    loading,
    actions,
    emailTemplateSettings = []
  } = props;

  useEffect(() => {
    if (emailTemplateSettings?.length > 0) {
      setEmailTemplateSettingsConfigured(
        emailTemplateSettings?.filter((item) => {
          return item?.isConfigured == "true";
        })
      );
    }
  }, [emailTemplateSettings]);

  const rows = emailConfigurationList.map((item, index) => {
    item.effectiveDate = new Date(item.effectiveDate);
    item.id = index;
    return item;
  });

  const initFetch = () => {
    actions.getEmailConfiguration(practiceId);
  };

  useEffect(() => {
    actions.getEmailTemplateSetting();
  }, []);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setIsMessageModal(true);
    }
    initFetch();

    return () => {
      actions.resetEmailConfiguration();
    };
  }, [addEmailConfiguration, editEmailConfiguration, errorMsg, successMsg]);

  const addEmailConfigure = () => {
    setValues(emailConfigurationFormData);
    setIsAdd(true);
    setIsOpen(true);
  };

  const saveEmailConfuration = (event) => {
    event.preventDefault();

    const findEmailtemplate = practiceStoreList?.find(
      (item) => item.practiceId == values?.practiceId
    );

    if (isAdd) {
      actions.addEmailConfiguration({
        ...values,
        createdBy: findEmailtemplate.createdBy,
        updatedBy: findEmailtemplate.updatedBy
      });
    } else {
      actions.editEmailConfiguration({
        ...values,
        practiceEmailMappingId: practiceEmailMappingId,
        createdBy: findEmailtemplate.createdBy,
        updatedBy: findEmailtemplate.updatedBy
      });
    }
    closeModal();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (event.target.type === "checkbox") {
      setValues({
        ...values,
        [name]: event.target.checked
      });
    } else {
      setValues({
        ...values,
        [name]: value
      });
    }
  };

  const handleEditEmailConfiguration = (row) => {
    setIsAdd(false);
    setIsOpen(true);
    setPracticeEmailMappingId(row?.practiceEmailMappingId);
    emailConfigurationFormData = {
      practiceId,
      emailTemplateId: row.emailTemplateId,
      isActive: row.isActive,
      followUpDays: row.followUpDays,
      isFollowUpEmail: row.isFollowUpEmail,
      emailType: row.emailType,
      createdBy: row.createdBy,
      updatedBy: row.updatedBy
    };
    setValues(emailConfigurationFormData);
  };

  const deleteEmailConfigurationDetail = () => {
    actions.deleteEmailConfiguration({
      practiceEmailMappingId: practiceEmailMappingId
    });

    closeModal();
  };

  const closeModal = () => {
    setValues(emailConfigurationFormData);
    setIsOpen(false);
  };

  const closeMessageModal = () => {
    setIsMessageModal(false);
    actions.resetMessage();
  };
  return (
    <>
      <Box>
        <Button
          variant="contained"
          onClick={addEmailConfigure}
          className="btn-primary tab-panel-btn">
          New Email Configuration
        </Button>
      </Box>
      <Box className="grid-style" sx={{ height: "660px" }}>
        <DataGridPremiumComp
          rows={rows}
          rowCount={rows.length}
          columns={columns}
          loading={loading}
          pageSizeOptions={[10, 25, 50, 100]}
          pageSize={pageSize.pageSize}
          paginationModel={pageSize}
          onPaginationModelChange={(newPageSize) => setPageSize(newPageSize)}
          pagination
        />
      </Box>
      {/* Add/edit email Document modal*/}
      <Modal open={isOpen} backdrop="static" aria-labelledby="modal-add-title">
        <Box component="form" onSubmit={saveEmailConfuration} className="modal-style">
          <Stack direction="row" className="modal-stack">
            <Typography>
              {isAdd ? "New Email Configuration" : "Edit Email Configuration"}
            </Typography>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </Stack>
          <Divider className="modal-divider" />
          <Stack direction="row" className="modal-stack">
            <InputLabel required flex={1}>
              Email Template ID
            </InputLabel>
            <Select
              size="small"
              id="email-template-id"
              name="emailTemplateId"
              sx={{ minWidth: 300 }}
              required
              value={values.emailTemplateId}
              onChange={handleInputChange}>
              {emailTemplateSettingsConfigured.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.id} - {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </Stack>

          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel>Follow Up Days*</InputLabel>
            </Grid>
            <TextField
              // disabled={true}
              size="small"
              value={values.followUpDays}
              className=""
              sx={{ minWidth: 300 }}
              name="followUpDays"
              onChange={handleInputChange}
            />
          </Stack>

          <Stack direction="row" className="modal-stack">
            <InputLabel required flex={1}>
              Email Type
            </InputLabel>
            <Select
              size="small"
              id="email-template-id"
              name="emailType"
              sx={{ minWidth: 300 }}
              required
              value={values.emailType}
              onChange={handleInputChange}>
              <MenuItem value="PROMOTIONAL">PROMOTIONAL</MenuItem>
              <MenuItem value="TRANSACTIONAL">TRANSACTIONAL</MenuItem>
              <MenuItem value="REMINDER">REMINDER</MenuItem>
            </Select>
          </Stack>

          <Stack direction="row" className="modal-stack">
            <InputLabel required flex={1}>
              Is Active
            </InputLabel>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  color="primary"
                  name="isActive"
                  value={values.isActive}
                  checked={values.isActive}
                  onChange={handleInputChange}
                />
              }
              labelPlacement="start"
            />
          </Stack>

          <Stack direction="row" className="modal-stack">
            <InputLabel required flex={1}>
              Is Follow Up Email
            </InputLabel>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  color="primary"
                  name="isFollowUpEmail"
                  value={values.isFollowUpEmail}
                  checked={values.isFollowUpEmail}
                  onChange={handleInputChange}
                />
              }
              labelPlacement="start"
            />
          </Stack>

          <Stack direction="row" spacing={2} className="modal-bottom-section">
            <Button variant="outlined" className="btn-primary" onClick={closeModal}>
              Cancel
            </Button>
            <Stack
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center"
              }}>
              {!isAdd && (
                <Button
                  variant="contained"
                  disabled={!values?.emailTemplateId || !values?.emailType}
                  className="btn-usf"
                  style={{ marginRight: "5px" }}
                  onClick={() => {
                    deleteEmailConfigurationDetail();
                  }}>
                  {"Delete"}
                </Button>
              )}
              <Button
                type="submit"
                variant="contained"
                disabled={!values?.emailTemplateId || !values?.emailType}
                className="btn-usf">
                {isAdd ? "Create" : "Edit"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <MessageModal
        open={isMessageModal}
        message={successMsg}
        error={errorMsg}
        closeModal={closeMessageModal}
      />
    </>
  );
};

const mapStateToProps = ({ emailConfigurationReducer, emailTemplateReducer }) => {
  return {
    emailConfigurationList: emailConfigurationReducer.emailConfigurationList,
    loading: emailConfigurationReducer.loading,
    emailTemplateSettings: emailTemplateReducer.emailTemplateSettings,
    addEmailConfiguration: emailConfigurationReducer.addEmailConfiguration,
    editEmailConfiguration: emailConfigurationReducer.editEmailConfiguration,
    successMsg: emailConfigurationReducer.success,
    errorMsg: emailConfigurationReducer.error
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getEmailConfiguration: (practiceId) => {
      dispatch(actionType.getEmailConfiguration(practiceId));
    },
    addEmailConfiguration: (payload) => {
      dispatch(actionType.addEmailConfiguration(payload));
    },
    deleteEmailConfiguration: (payload) => {
      dispatch(actionType.deleteEmailConfiguration(payload));
    },
    editEmailConfiguration: (payload) => {
      dispatch(actionType.editEmailConfiguration(payload));
    },
    resetEmailConfiguration: () => {
      dispatch(actionType.resetEmailConfiguration());
    },
    resetMessage: () => {
      dispatch(actionType.resetMessage());
    },
    getEmailTemplateSetting: () => {
      dispatch(actionType.getEmailTemplateSetting());
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfiguration);
